import axios from "axios";

// ✅ Base URL for your server
const SERVER_URL = "https://api.malidag.com";

// ✅ Add category
export const addCategory = async (categoryName) => {
  try {
    const response = await axios.post(`${SERVER_URL}/add-category`, { categoryName });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// ✅ Add type (supports both image file or URL)
export const addTypeToCategory = async (categoryName, typeName, imageFileOrUrl) => {
  try {
    const formData = new FormData();
    formData.append("categoryName", categoryName);
    formData.append("typeName", typeName);

    // If a file object, append it as multipart file; otherwise send as URL
    if (imageFileOrUrl instanceof File) {
      formData.append("image", imageFileOrUrl);
    } else if (typeof imageFileOrUrl === "string") {
      formData.append("imageUrl", imageFileOrUrl);
    }

    const response = await axios.post(`${SERVER_URL}/add-type`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
